const getSortedArray = (sortByMaterial, pricesDataArr) => {
  if (pricesDataArr?.length > 0) {
    return pricesDataArr.sort((bracket1, bracket2) => {
      // Handle 1stRecommended and 2ndRecommended priorities
      if (bracket1['1stRecommended'] && !bracket2['1stRecommended']) {
        return -1; // bracket1 comes first
      } else if (!bracket1['1stRecommended'] && bracket2['1stRecommended']) {
        return 1; // bracket2 comes first
      }

      if (bracket1['2ndRecommended'] && !bracket2['2ndRecommended']) {
        return -1; // bracket1 comes first
      } else if (!bracket1['2ndRecommended'] && bracket2['2ndRecommended']) {
        return 1; // bracket2 comes first
      }
      // Find the matching material objects in each object's materials list
      const material1 = bracket1.materials.find((material) => sortByMaterial === material.material);
      const material2 = bracket2.materials.find((material) => sortByMaterial === material.material);
      // Handle cases where the material is not found in either object
      if (!material1 && !material2) {
        return 0; // Both objects have no matching material, so their order doesn't matter
      } else if (!material1) {
        return 1; // Object 2 has the material while Object 1 doesn't, so Object 2 comes first
      } else if (!material2) {
        return -1; // Object 1 has the material while Object 2 doesn't, so Object 1 comes first
      }
      // Sort by price of the matching materials
      return material1.price - material2.price;
    });
  }
  return [];
};

// get object for image box with prices
const getImageDataWithMaterialsPrices = (imageData, pricesDataArr) => {
  const materials =
    pricesDataArr?.find(
      //apply or condition for api data because api return name
      //instead of title
      (pricesObj) => pricesObj.name === imageData.name
    )?.materials || [];

  return {
    ...imageData,
    materials: materials
  };
};

export const getImagesDataWithMaterialsPrices = (imagesData, pricesDataArr, sortByMaterial) => {
  if (imagesData?.length < 1) return imagesData;
  const imageDataWithPrices = imagesData?.map((imgData) => {
    return getImageDataWithMaterialsPrices(imgData, pricesDataArr);
  });

  if (!sortByMaterial) return imageDataWithPrices;

  return getSortedArray(sortByMaterial, imageDataWithPrices);
};

export const convertNumber = (num, divider) => {
  if (Number.isInteger(num)) return num;

  const wholePart = Math.floor(num);
  const fraction = num - wholePart;

  let divided = fraction * divider;

  for (let i = divided; i > 1; i--) {
    if (!(divided % i) && !(divider % i)) {
      return `${wholePart} ${divided / i}/${divider / i}`;
    }
  }

  return `${wholePart} ${fraction * divider}/${divider}`;
};
